'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var modalTypes = {
    ABSENTEE_BID: 'ABSENTEE_BID',
    ADD_CREDIT_CARD: 'ADD_CREDIT_CARD',
    ADD_SEARCH_ALERT: 'ADD_SEARCH_ALERT',
    BUY_NOW: 'BUY_NOW',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CLASSIC_BIDDING_CONSOLE: 'CLASSIC_BIDDING_CONSOLE',
    COMPLETE_ACCOUNT: 'COMPLETE_ACCOUNT',
    CONFIRM_CONSIGNMENT: 'CONFIRM_CONSIGNMENT',
    CONFIRM_PASSWORD: 'CONFIRM_PASSWORD',
    CONSENT: 'CONSENT',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    HEALTHCHECK: 'HEALTHCHECK',
    INSTALL_FLASH: 'INSTALL_FLASH',
    ITEM_DESCRIPTION: 'ITEM_DESCRIPTION',
    LIVE_BID: 'LIVE_BID',
    LOGIN: 'LOGIN',
    MAKE_OFFER: 'MAKE_OFFER',
    NONE: 'NONE',
    REGISTER_FOR_AUCTION: 'REGISTER_FOR_AUCTION',
    RETRACT_BID: 'RETRACT_BID',
    SEND_SELLER_CONSIGNMENT_MESSAGE: 'SEND_SELLER_CONSIGNMENT_MESSAGE',
    SEND_SELLER_MESSAGE: 'SEND_SELLER_MESSAGE',
    SET_PASSWORD: 'SET_PASSWORD',
    SIGN_UP: 'SIGN_UP',
    TERMS: 'TERMS'
};

exports.default = modalTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/modalTypes.js
// module id = GlFK
// module chunks = 60